import React from 'react';
import { Platform } from 'src/libs/platform';
import ChevronLeft from 'src/assets/icons/chevron-left.svg';
import ArrowLeft from 'src/assets/icons/arrow-left.svg';
import { PanelHeaderButton, PanelHeaderButtonProps } from './PanelHeaderButton';

export type PanelHeaderBackProps = Omit<PanelHeaderButtonProps, 'children'>;

export const PanelHeaderBack: React.FC<PanelHeaderBackProps> = props =>
  Platform.OS === 'ios' ? (
    <PanelHeaderButton {...props}>
      <ChevronLeft />
    </PanelHeaderButton>
  ) : (
    <PanelHeaderButton {...props}>
      <ArrowLeft />
    </PanelHeaderButton>
  );
